import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QuestionSchemaInput from '../QuestionSchemaInput';

export default class extends Component {
  static propTypes = {
    section: PropTypes.object.isRequired,
    questionSchemaInputProps: PropTypes.object.isRequired,
  }

  render() {
    return (
      <QuestionSchemaInput
        renderSection
        sectionProps={{
          title: this.props.section.title,
          previewButtonProps: {
            previewPath: this.props.section.previewPath,
            target: this.props.section.slug,
            disabledTooltip: 'The user will not see this section because it has no questions.',
          },
        }}
        {...this.props.questionSchemaInputProps}
      />
    );
  }
}
